
import { defuFn } from '/data/www/batobs.org/vleermuisvang-db/nuxt/node_modules/.pnpm/defu@6.1.2/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}

import cfg0 from "/data/www/batobs.org/vleermuisvang-db/nuxt/node_modules/.pnpm/@bttr-devs+nuxt-layer-sofie@1.0.0-beta.14_@unhead+vue@1.1.27_nuxt@3.5.3_react-dom@18.2.0_reac_k7f22vbjop3t4ieda43xusqfoy/node_modules/@bttr-devs/nuxt-layer-sofie/app.config.ts"
import cfg1 from "/data/www/batobs.org/vleermuisvang-db/nuxt/node_modules/.pnpm/@bttr-devs+nuxt-layer-base@1.0.0-beta.14_@unhead+vue@1.1.27_nuxt@3.5.3_tailwindcss@3.3.2_vue@3.3.4_webpack@5.86.0/node_modules/@bttr-devs/nuxt-layer-base/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, cfg1, inlineConfig)
